import { DEFAULT_SITE_COPY } from "../localeConfig";

function normalizeStrapiPayload(json) {
  if (!json || typeof json !== "object") return null;
  const d = json.data;
  if (!d) return null;
  if (d.attributes && typeof d.attributes === "object") return d.attributes;
  const {
    id: _id,
    documentId: _documentId,
    locale: _locale,
    createdAt: _c,
    updatedAt: _u,
    publishedAt: _p,
    ...rest
  } = d;
  return rest;
}

/**
 * Fetches localized site copy from Strapi.
 * Uses CRA dev proxy (same-origin `/api`) when REACT_APP_STRAPI_URL is unset.
 */
export async function fetchSiteCopy(locale) {
  const base = (process.env.REACT_APP_STRAPI_URL || "").replace(/\/$/, "");
  const path = `/api/site-copy?locale=${encodeURIComponent(locale)}`;
  const url = base ? `${base}${path}` : path;

  const res = await fetch(url);
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`Strapi ${res.status}: ${text.slice(0, 200)}`);
  }

  const json = await res.json();
  const attrs = normalizeStrapiPayload(json);
  return { ...DEFAULT_SITE_COPY, ...(attrs || {}) };
}
